export default "__VITE_ASSET__e9bbc680__"